/**
 * @module components\FgPass
 */
import Vue from "vue";
import Component from "vue-class-component";
import { required, sameAs, maxLength, minLength } from "vuelidate/lib/validators";
import sToast from "@/services/sToast";
import core from "@/services/core";
import { customPattern } from "@/validations/customPattern";
var shajs = require("sha.js");
@Component({
  validations: function (this: FgPass) {
    let validation: any = {
      loginCredentials: {
        loginId: {
          required,
          minLength: minLength(this.loginCredentials.userType == 'ADMIN' ? 1 : 10),
          maxLength: maxLength(this.loginCredentials.userType == 'ADMIN' ? 20 : 10)
        },
        userType: {
          required
        }
      },
      modifyPass: {
        otp: {
          required
        },
        newPassword: {
          required,
          customPattern: customPattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,20})')
        },
        confirmPassword: {
          required,
          sameAs: sameAs("newPassword")
        }
      }
    }
    return validation;
  }
})
export default class FgPass extends Vue {
  dialog = false;
  isIdAvailable = false;
  loading = false;
  loadingSetPass = false;
  loginCredentials = { loginId: "", userType: "" };
  modifyPass = { otp: "", newPassword: "", confirmPassword: "" };
  forgotPasswordResponse = {
    randomSeed: "",
    hashCount: "",
    otpId: "",
    agentMobileNo: "",
    waitDesc: ""
  };
  submitForgot() {
    this.$v.loginCredentials.$touch();
    if (this.$v.loginCredentials!.loginId!.$invalid) {
      return false;
    }
    this.loading = true;
    let request = {
      userType: this.loginCredentials.userType,
      loginId: this.loginCredentials.loginId,
      reqType: "WEB",
      reqBy: "WEB",
      reqMode: "WEB"
    }
    core
      .post({
        data: request,
        url: 'forgotPassword',
        method: 'post'
      })
      .then(response => {
        this.forgotPasswordResponse = response;
        this.isIdAvailable = true;
        this.loading = false;
        sToast.show({
          message: this.forgotPasswordResponse.waitDesc,
          intent: "success",
          timeout: 10000
        });
      })
      .catch(error => {
        this.loading = false;
      });
  }
  setPassword() {
    if (this.$v.modifyPass!.$invalid) {
      this.$v.modifyPass.$touch();
      return
    }
    this.loadingSetPass = true;
    let request = {
      loginId: this.loginCredentials.loginId,
      hashCount: this.forgotPasswordResponse.hashCount,
      randomSeed: this.forgotPasswordResponse.randomSeed,
      otpId: this.forgotPasswordResponse.otpId,
      mobileNo: this.forgotPasswordResponse.agentMobileNo,
      userType: this.loginCredentials.userType,
      masterHashOtp: this.createMasterHash(),
      pwd: this.getHashedString(this.modifyPass.confirmPassword)
    };
    core
      .post({
        data: request,
        url: 'setPassword',
        method: 'post'
      })
      .then(response => {
        this.forgotPasswordResponse = response;
        this.isIdAvailable = true;
        this.loadingSetPass = false;
        this.dialog = true;
      })
      .catch(error => {
        this.loadingSetPass = false;
      });
  }
  navigate() {
    this.$router.replace({ name: 'login' })
  }

  createMasterHash() {
    let masterHashPwd = this.getHashedString(this.modifyPass.otp);
    for (let i = parseInt(this.forgotPasswordResponse.hashCount); i > 0; i--) {
      masterHashPwd = this.getHashedString(masterHashPwd.substring(0, i) + this.forgotPasswordResponse.randomSeed + masterHashPwd.substring(i));
    }
    return masterHashPwd;
  }

  getHashedString(string) {
    return shajs("sha256").update(string).digest("hex");
  }
}
